module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogoGcf.ce1a3081.png";